import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
const initialState = {
  isLoading: false,
  error: null,
  appointments: [],
  totalAppointments: 0,
  currentPage: 1,
  totalPages: 1,
};

const slice = createSlice({
  name: 'appointments',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getAppointmentsSuccess(state, action) {
      state.isLoading = false;
      state.appointments = action.payload.appointments || [];
      state.totalAppointments = action.payload.total || 0;
      state.currentPage = action.payload.currentPage || 1;
      state.totalPages = action.payload.totalPages || 1;
    },

    updateAppointmentSuccess(state, action) {
      state.isLoading = false;
      const index = state.appointments.findIndex((item) => item._id === action.payload._id);
      if (index !== -1) {
        state.appointments[index] = action.payload;
      }
    },

    deleteAppointmentSuccess(state, action) {
      state.isLoading = false;
    },

    assignStylistSuccess(state, action) {
      state.isLoading = false;
      const index = state.appointments.findIndex((item) => item._id === action.payload._id);
      if (index !== -1) {
        state.appointments[index] = action.payload;
      }
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getAllAppointments(params = {}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.appointmentType) queryParams.append('appointmentType', params.appointmentType);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.stylistId) queryParams.append('stylistId', params.stylistId);

      const response = await axios.get(`/api/admin/appointments?${queryParams.toString()}`);
      dispatch(slice.actions.getAppointmentsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateAppointment(id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put('/api/customer/appointments', data);
      dispatch(slice.actions.updateAppointmentSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteAppointment(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`/api/admin/appointments/${id}`);
      dispatch(slice.actions.deleteAppointmentSuccess(id));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function assignStylist(appointmentId, stylistId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/api/admin/appointments/${appointmentId}/assign-stylist`, {
        stylistId,
      });
      dispatch(slice.actions.assignStylistSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
